import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import { createPinia } from 'pinia'
import IdmUI from '@idomoo-hub/library';
import posthogPlugin from "@/plugins/posthog";
import JsonViewer from "vue3-json-viewer";

import "vue3-json-viewer/dist/vue3-json-viewer.css";
import '@/css/main.scss';

const lastViewedScenesId = (() => {
    try {
        const a = JSON.parse(localStorage.getItem("lastViewedScenes"));
        return Array.isArray(a) && a.length ? a[0].id || '' : ''
    } catch {
        return ''
    }
})();

const app = createApp(App)
  .use(router)
  .use(createPinia())
  .use(IdmUI, {auth:{
      debug: true,
      api_url: import.meta.env.VITE_APP_API_URL,
      login_url: import.meta.env.VITE_APP_LOGIN_URL + lastViewedScenesId,
      logout_url: import.meta.env.VITE_APP_LOGOUT_URL,
      apolloConnectToDevTools: process.env.NODE_ENV !== 'production',
      disabledIntegrations: {kaltura: true,hubspot: true,adobe:true}
    }})
  .use(JsonViewer);

if(import.meta.env.VITE_APP_DISABLE_POSTHOG != "true"){
  app.use(posthogPlugin);
}
app.mount('#app');

console.log(`%cScene Creator v.${import.meta.env.VITE_APP_VERSION} (BuildTime: ${import.meta.env.VITE_APP_BUILDTIME})%cENV: ${process.env.NODE_ENV}%c${import.meta.env.VITE_APP_GIT_HASH}`,
  'background:#07354A;color:#fff;font-weight:900;padding:3px 5px;border-radius:5px;margin-right:10px',
  'background:#aaa;color:#222;font-weight:900;padding:3px 5px;border-radius:5px;margin-right:10px',
  'background:#aaa;color:#222;font-weight:900;padding:3px 5px;border-radius:5px');